import { UrlParser, ContentType } from "@authory-packages/core";
import { V3CaptionGrey48 } from "../../ReusableStyledComponents/V3CaptionGrey48";
import { VerticalSpacing } from "../../VerticalSpacing";
import { V3Button } from "../../Button";
import { RightAlignPanel } from "../../ReusableStyledComponents/RightAlignPanel";
import { V3ButtonColor } from "../../Button/V3Button.types";
import { RoundedBoxCTA } from "../SharedComponents/RoundedBoxCTA";
import { ManualImportPathTaken } from "../UniversalAddContentTracking";

interface AddSourceContentNotFoundProps {
    userName: string;
    url: string;
    onBackHandler: () => void;
    goToAddManual: (pathTaken: ManualImportPathTaken, isSnippetImport: boolean, targetContentType: ContentType) => void;
    onImportEverything: () => void;
    onSomethingElse: () => void;
    aliases: string[];
    loading?: boolean;
}

export const AddSourceContentNotFound = ({
    userName,
    url,
    onBackHandler,
    onImportEverything,
    onSomethingElse,
    goToAddManual,
    aliases
}: AddSourceContentNotFoundProps) => {
    let domain = "";

    try {
        domain = UrlParser.extractDomain(url) || "";
    } catch {}

    return (
        <>
            <VerticalSpacing bottom={12}>
                <V3CaptionGrey48>
                    We couldn't find any articles with the byline <strong>{userName}</strong>{" "}
                    {aliases.length ? <> or any of your aliases ({aliases.join(", ")})</> : <></>} at <strong>{domain}</strong>
                </V3CaptionGrey48>
            </VerticalSpacing>
            <VerticalSpacing bottom={24}>
                <V3CaptionGrey48>
                    Please double check if that's the same byline that's displayed on the example article. Not using the exact same byline is the most
                    common reason for the automated importing not working.
                </V3CaptionGrey48>
            </VerticalSpacing>
            <VerticalSpacing bottom={12}>
                <V3CaptionGrey48>
                    <strong>Let's figure out what's going on. Select an option below.</strong>
                </V3CaptionGrey48>
            </VerticalSpacing>
            <RoundedBoxCTA text="I use another byline" onClick={onBackHandler} />
            <RoundedBoxCTA text="Import all articles from this publication" onClick={onImportEverything} />
            <RoundedBoxCTA
                text="I want to import non-bylined content"
                onClick={() => {
                    goToAddManual(ManualImportPathTaken.AddSourceNonBylinedContent, false, ContentType.Article);
                }}
            />
            <RoundedBoxCTA text="It's something else" onClick={onSomethingElse} />
            <VerticalSpacing top={24}>
                <RightAlignPanel>
                    <div>
                        <V3Button text="Back" autoWidth onClick={onBackHandler} color={V3ButtonColor.secondary} />
                    </div>
                </RightAlignPanel>
            </VerticalSpacing>
        </>
    );
};
